define('services/divisionService',[
    'lib/lodash4',
    'services/apiCore'
], function (_, apiCore) {
    'use strict';

    var DIVISION_URI = '/authorization/divisions';
    var DIVISION_PERMITTED_URI = '/authorization/divisionspermitted/me';

    var divisionService = {
        getDivision: function (id) {
            return apiCore.v2.get(DIVISION_URI + '/' + id);
        },

        getDivisions: function () {
            return apiCore.v2.get(DIVISION_URI, { pageSize: 100 })
                            .then(function (response) {
                                if (response && response.entities) {
                                    return response.entities;
                                }
                                return [];
                            });
        },

        getOrgDivisions: function () {
            return apiCore.v2.get(DIVISION_URI, { pageSize: 100 })
                            .then(function (response) {
                                return response || {};
                            });
        },

        getDivisionsPermitted: function (permission, params) {
            params = _.assign({ pageSize: 100, permission: permission }, params);
            return apiCore.v2.get(DIVISION_PERMITTED_URI, params)
                            .then(function (response) {
                                return response || [];
                            });
        }
    };

    return divisionService;

});
